var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DxTextArea',{attrs:{"value":_vm.additionalInfo,"on-value-changed":_vm.additionalInfoEvent,"max-length":"256"}})}
var staticRenderFns = []

export { render, staticRenderFns }